import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { removeDuplicateTickets } from "../../../utilities/helpers";

import Stack from "react-bootstrap/Stack";

import { Event } from "./Event";
import { EventDetailsWrapper } from "./EventDetailsWrapper";

export default function EventsList({ orders, getMyTickets }) {
  console.log("EventsList: orders: ", orders);
  const navigate = useNavigate();
  const location = useLocation();

  const [order, setOrder] = useState();

  const getUniqueTickets = (order) => {
    // remove duplicate tickets in packages
    if (order?.package) {
      const numGeneralAdmisionTickets =
        order?.tickets?.length / order?.package?.events?.length;

      return order?.tickets[0]?.generalAdmission
        ? order?.tickets?.slice(0, numGeneralAdmisionTickets)
        : removeDuplicateTickets(order?.tickets);
    }
    return order?.tickets;
  };

  // handle different views
  const handleClick = (_, order) => {
    console.log("handle click", order);
    if (!order) {
      navigate("/my-events");
      setOrder();
    } else {
      setOrder(order);
      navigate(`event-details/${order?.event?.uuid}`);
    }
  };

  const groupTicketsByEvent = (orders) => {
    const eventsMap = new Map();

    // Loop through each order (can be for a single event or a package)
    orders?.forEach((order) => {
      // === CASE 1: Single-event order ===
      if (order?.event?.uuid && order?.tickets) {
        const eventUuid = order.event.uuid;

        // Initialize the map entry for the event if it doesn't exist
        if (!eventsMap.has(eventUuid)) {
          eventsMap.set(eventUuid, {
            eventDetails: order.event,
            tickets: [],
          });
        }

        // Filter tickets that belong to this event
        const eventTickets = order.tickets.filter(
          (ticket) => ticket.eventId === eventUuid,
        );

        // Add them to the event’s ticket list in the map
        eventsMap.get(eventUuid).tickets.push(...eventTickets);

        // === CASE 2: Package order with multiple events ===
      } else if (order?.package?.events && order?.tickets) {
        order.package.events.forEach((pkgEvent) => {
          if (pkgEvent?.uuid) {
            const eventUuid = pkgEvent.uuid;

            // Initialize the map entry for the event if it doesn't exist
            if (!eventsMap.has(eventUuid)) {
              eventsMap.set(eventUuid, {
                eventDetails: pkgEvent,
                tickets: [],
              });
            }

            // Filter tickets belonging to this specific event inside the package
            const eventTickets = order.tickets.filter(
              (ticket) => ticket.eventId === eventUuid,
            );

            // Use getUniqueTickets to avoid duplicating tickets across multiple iterations
            // This assumes getUniqueTickets returns tickets not already in the array
            const uniqueTickets = getUniqueTickets({
              ...order,
              tickets: [...eventTickets],
            });

            // Add only unique tickets to this event
            eventsMap.get(eventUuid).tickets = [
              ...eventsMap.get(eventUuid).tickets,
              ...uniqueTickets,
            ];
          }
        });
      }
    });

    console.log("groupTicketsByEvent: eventsMap: ", eventsMap);
    return eventsMap; // Map<eventUuid, { eventDetails, tickets[] }>
  };

  const sortedMap = new Map(
    [...groupTicketsByEvent(orders).entries()].sort((a, b) => {
      const dateA = new Date(a[1].eventDetails.start);
      const dateB = new Date(b[1].eventDetails.start);
      return dateA - dateB; // ascending order
    }),
  );

  const grouped = sortedMap;
  console.log("grroupTickets", grouped);
  console.log("grroupTickets", Array.from(grouped.entries()));

  return (
    <>
      {!location.pathname.includes("/my-events/event-details") ? (
        <Stack gap={3} as="ul">
          {[...grouped.entries()].map(([key, value]) => (
            <Event
              key={key}
              event={value.eventDetails}
              tickets={value.tickets}
              handleClick={handleClick}
            />
          ))}
        </Stack>
      ) : (
        <EventDetailsWrapper order={order} getMyTickets={getMyTickets} />
      )}
    </>
  );
}
